import { useEffect, useState } from "react"

export const DynamicIsiHook = location => {
  const [scrollTo, setScrollTo] = useState("contraindications")

  const handleDynamicIsi = () => {
    const triggers = document.querySelectorAll("[data-isi-trigger]")
    let visibleTrigger = ""

    triggers.forEach(trigger => {
      if (trigger) {
        const rect = trigger.getBoundingClientRect()
        const viewPortBottom = window.innerHeight
        // swap ISI as soon as trigger is visible on screen
        if (
          rect.top <=
          viewPortBottom -
            document.querySelector("[data-id='sticky-isi']").offsetHeight -
            16
        ) {
          visibleTrigger = trigger.dataset.isiTrigger
        }
      }
      if(window.scrollY === 0) {
        visibleTrigger = "contraindications"
      }
    })

    setScrollTo(visibleTrigger)
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleDynamicIsi)
    }

    return () => {
      window.removeEventListener("scroll", handleDynamicIsi)
    }
  }, [location])

  return scrollTo
}
